import { TeamModel } from '../../domain/model/team.model'
import { getUser } from './storage/user'
import { addLocalStorage, getLocalStorage, removeLocalStorage } from './storage_helpers'

export const getTeam = () => {
  if (getUser()) {
    return {
      '@id': getUser()?.team ? getUser()?.team['@id'] : null,
      '@type': getUser()?.team ? getUser()?.team['@type'] : null,
      id: getUser()?.team ? Number(getUser()?.team['@id'].replace('/teams/', '')) : null,
      name: getUser()?.team?.name
    }
  }
  const team = getLocalStorage('team') || null
  if (team) return JSON.parse(team)

  return null
}

export const setTeam = async (team:TeamModel|any) => {
  await addLocalStorage('team', JSON.stringify(team))
}

export const removeTeam = () => {
  removeLocalStorage('user')
}
